import { render, staticRenderFns } from "./warning.vue?vue&type=template&id=2a714152&scoped=true"
import script from "./warning.vue?vue&type=script&lang=ts"
export * from "./warning.vue?vue&type=script&lang=ts"
import style0 from "./warning.vue?vue&type=style&index=0&id=2a714152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a714152",
  null
  
)

export default component.exports